import React from "react"
import { useAlgoliaSearchState } from "../../controller/state"
import { CategoriesTreeItem } from "../../controller/state/categories"
import CheckboxFilterTag from "../CheckboxFilterTag"
import { getSelectedCategories } from "./hooks"

export const CategoryTagItems = () => {
  const {
    uiFilters,
    searchParams,
    updateSearchParams,
  } = useAlgoliaSearchState()

  if (!uiFilters?.categories) {
    return <></>
  }

  const selectedRootCategories = getSelectedCategories(uiFilters.categories)

  const handleUnselect = (node: CategoriesTreeItem) => {
    const newCodes =
      searchParams.categoryCodes?.filter((x) => !node.allCodes.includes(x)) ??
      []

    console.log("remove", node, searchParams, newCodes)

    updateSearchParams((state) => {
      return {
        ...state,
        categoryCodes: newCodes,
      }
    })
  }

  return (
    <>
      {selectedRootCategories.map((x, index) => (
        <div key={index} className="mb-2 mr-2">
          <CheckboxFilterTag
            label={x.label}
            onRemove={() => handleUnselect(x)}
          />
        </div>
      ))}
    </>
  )
}
